// extracted by mini-css-extract-plugin
export var firstColumn = "TwoColumnRte-module--firstColumn--a6978";
export var secondColumn = "TwoColumnRte-module--secondColumn--b813e";
export var twocolumnrte = "TwoColumnRte-module--twocolumnrte--ca5ab";